module.exports = __webpack_public_path__ + "img/Bodice-Front-B10-Gb-Da-Ea.b5f5515c.png";